import 'quill/dist/quill.snow.css'
import React, {useContext, useEffect, useMemo, useRef} from 'react'
import {ErrorCode} from '../../config/ErrorCode'
import {runAsync} from '../../helpers/util'
import {PhotosPreviewContext} from '../common/PhotoPreview'
import {useAsync} from '../hocs/hooks'
import {attachImageBlotPreviewHandlers} from './ImageBlot'
import {loadInstagram, reloadInstagram} from './InstagramBlot'
import {loadTwitter, reloadTweets} from './TwitterBlot'

const Preview = ({content}: { content: string }) => {
  const openPreview = useContext(PhotosPreviewContext)!
  const containerRef = useRef<HTMLElement>()
  useEffect(() => {
    runAsync(ErrorCode.previewLoadInstagram, loadInstagram())
  }, [])
  const { loading, result: twttr } = useAsync(loadTwitter, true)
  useEffect(() => {
    reloadInstagram()
    const unobserveImgs = attachImageBlotPreviewHandlers(containerRef.current!, openPreview)
    return () => {
      unobserveImgs()
    }
  }, [content, openPreview])
  const innerHtml = useMemo(() => ({__html: content}), [content])
  const innerHtmlRef = useRef<HTMLElement>()
  useEffect(() => {
    if (!loading && innerHtmlRef.current && twttr) {
      reloadTweets(twttr, innerHtmlRef.current)
    }
  }, [loading, innerHtmlRef])

  return <div className="ql-snow ql-container no-border pt-3" ref={containerRef}>
    <div className="ql-editor px-0 pb-0 pt-md-1 overflow-hidden">
      <div ref={innerHtmlRef} dangerouslySetInnerHTML={innerHtml}/>
    </div>
  </div>
}
Preview.displayName = 'Preview'
export default Preview
